import IconVideo from "../icon/IconVideo";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

export default function IconButtonVideo(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconVideo />
    </IconButtonContainer>
}
